"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var s = _interopRequireWildcard(require("./styles"));

var _IconInvite = _interopRequireDefault(require("../../../Icons/IconInvite"));

var _index = _interopRequireDefault(require("./UserProgress/index"));

var _UserActions = _interopRequireDefault(require("./UserActions"));

var _helper = require("../helper");

var _DarkText = _interopRequireDefault(require("../../../DarkText"));

var _UserLiveClassStatus = _interopRequireDefault(require("./UserLiveClassStatus"));

// import LiveClassUserPeformance from './LiveClassUserPeformance';
function renderUserImage(props) {
  var image = props.image,
      picture = props.picture,
      name = props.name,
      size = props.size,
      showInviteLearner = props.showInviteLearner,
      onStageStatus = props.onStageStatus,
      _onClick = props.onClick;
  var onStage = (0, _helper.isUserOnStage)(onStageStatus);
  return React.createElement(React.Fragment, null, React.createElement("img", {
    src: image || picture,
    alt: name,
    className: (0, _classnames.default)(s.userImage, "w-".concat(size))
  }), showInviteLearner ? React.createElement("div", {
    className: (0, _classnames.default)(s.overlay, onStage ? 'stage' : ''),
    onClick: function onClick() {
      return _onClick(props);
    },
    role: "button",
    tabIndex: "0"
  }, onStage ? React.createElement(React.Fragment, null, React.createElement(_IconInvite.default, null), React.createElement(_DarkText.default, {
    color: "silver",
    fontSize: 10
  }, "Remove from stage")) : React.createElement(React.Fragment, null, React.createElement(_IconInvite.default, null), React.createElement(_DarkText.default, {
    color: "silver",
    fontSize: 10
  }, "Bring onstage"))) : null);
}

function renderUserImageRound(props) {
  var image = props.image,
      picture = props.picture,
      name = props.name,
      showInviteLearner = props.showInviteLearner,
      onStageStatus = props.onStageStatus,
      _onClick2 = props.onClick;
  var onStage = (0, _helper.isUserOnStage)(onStageStatus);
  return React.createElement(React.Fragment, null, React.createElement("img", {
    src: image || picture,
    alt: name,
    className: s.roundImage
  }), showInviteLearner ? React.createElement("div", {
    className: (0, _classnames.default)(s.overlayRound, onStage ? 'stage' : ''),
    onClick: function onClick() {
      return _onClick2(props);
    },
    role: "button",
    tabIndex: "0"
  }, onStage ? React.createElement(_IconInvite.default, null) : React.createElement(_IconInvite.default, null)) : null);
}

function renderUserName(name) {
  return React.createElement(_DarkText.default, {
    fontSize: "12",
    color: "silver",
    className: s.userName
  }, name);
}

function renderListView(props) {
  var id = props.id,
      name = props.name,
      hasLowAttention = props.hasLowAttention,
      isRaisingHand = props.isRaisingHand,
      progress = props.progress,
      progressOn = props.progressOn,
      onStageStatus = props.onStageStatus,
      isClassActive = props.isClassActive,
      assetProgress = props.assetProgress,
      isLearner = props.isLearner,
      audioStatus = props.audioStatus;
  var onStage = (0, _helper.isUserOnStage)(onStageStatus);
  return React.createElement("div", {
    className: (0, _classnames.default)(s.userListContainer, "".concat(onStage ? 'onStage' : ''))
  }, onStage ? React.createElement("div", {
    className: (0, _classnames.default)(s.onStageSideBar, onStageStatus)
  }) : null, React.createElement("div", {
    className: s.listUserLeftContainer
  }, renderUserImageRound(props), React.createElement("div", {
    className: s.listNameProgressWrapper
  }, React.createElement("div", {
    className: s.listNameProgressTopWrapper
  }, renderUserName(name), React.createElement(_UserLiveClassStatus.default, {
    hasLowAttention: hasLowAttention,
    isRaisingHand: isRaisingHand,
    statusIconClass: s.statusIconClass,
    className: s.listStatusWrapper
  })), isClassActive ? React.createElement(_index.default, {
    progress: progress,
    assetProgress: assetProgress,
    progressOn: progressOn,
    className: s.progressListContainer
  }) : null)), isLearner ? null : React.createElement(_UserActions.default, {
    onActionSelect: props.onActionSelect,
    onStageStatus: onStageStatus,
    isClassActive: isClassActive,
    audioStatus: audioStatus,
    userId: id
  }));
}

function renderGridView(props) {
  var size = props.size,
      id = props.id,
      name = props.name,
      hasLowAttention = props.hasLowAttention,
      isRaisingHand = props.isRaisingHand,
      progress = props.progress,
      progressOn = props.progressOn,
      onStageStatus = props.onStageStatus,
      isClassActive = props.isClassActive,
      assetProgress = props.assetProgress,
      isLearner = props.isLearner,
      audioStatus = props.audioStatus;
  return React.createElement("div", {
    className: (0, _classnames.default)(s.itemGridContainer, "w-".concat(size), onStageStatus)
  }, React.createElement("div", {
    className: (0, _classnames.default)(s.userImageProgressContainer, "w-".concat(size))
  }, renderUserImage(props), isClassActive ? React.createElement(_index.default, {
    progress: progress,
    assetProgress: assetProgress,
    progressOn: progressOn,
    className: s.progressGridContainer
  }) : null), React.createElement("div", {
    className: (0, _classnames.default)(s.userNameActionContainer)
  }, renderUserName(name), isLearner ? null : React.createElement(_UserActions.default, {
    onActionSelect: props.onActionSelect,
    onStageStatus: onStageStatus,
    isClassActive: isClassActive,
    audioStatus: audioStatus,
    userId: id
  })), React.createElement(_UserLiveClassStatus.default, {
    hasLowAttention: hasLowAttention,
    isRaisingHand: isRaisingHand
  }));
}

function UserView(props) {
  var viewType = props.viewType;

  if (viewType === 'listView') {
    return renderListView(props);
  }

  return renderGridView(props);
}

UserView.defaultProps = {
  name: '',
  size: 'medium',
  email: '',
  image: '',
  picture: '',
  hasLowAttention: false,
  isRaisingHand: false,
  progress: 0,
  progressOn: '',
  onStageStatus: 'DEFAULT',
  userPerformance: null,
  viewType: 'grid',
  showInviteLearner: false,
  isClassActive: false,
  onClick: function onClick() {},
  assetProgress: {
    cardProgress: 0,
    progressOn: '',
    courseProgress: 0,
    courseName: ''
  },
  isLearner: true,
  audioStatus: 'PLAYING'
};
UserView.propTypes = {
  id: _propTypes.default.string.isRequired,
  viewType: _propTypes.default.string,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  name: _propTypes.default.string,
  email: _propTypes.default.string,
  image: _propTypes.default.string,
  picture: _propTypes.default.string,
  hasLowAttention: _propTypes.default.bool,
  isRaisingHand: _propTypes.default.bool,
  progress: _propTypes.default.number,
  progressOn: _propTypes.default.string,
  onStageStatus: _propTypes.default.string,
  userPerformance: _propTypes.default.shape({
    badges: _propTypes.default.number,
    certificates: _propTypes.default.number,
    overdue: _propTypes.default.number,
    notSubmitted: _propTypes.default.bool
  }),
  assetProgress: _propTypes.default.shape({
    cardProgress: _propTypes.default.number,
    progressOn: _propTypes.default.string,
    courseProgress: _propTypes.default.number,
    courseName: _propTypes.default.string
  }),
  onActionSelect: _propTypes.default.func.isRequired,
  showInviteLearner: _propTypes.default.bool,
  isClassActive: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  isLearner: _propTypes.default.bool,
  audioStatus: _propTypes.default.string
};
var _default = UserView;
exports.default = _default;